import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { Row, Col, Card } from 'react-bootstrap';
import { User } from 'oidc-client';
import DashboardsTable from './DashboardsTable';

type DashboardProps = {
    user: User;
}

class Dashboards extends React.Component<DashboardProps> {

    public render(){

        const username = !this.props.user ? "" : `${this.props.user.profile.given_name} ${this.props.user.profile.family_name}`;

        return(
            <React.Fragment>
                <Row>
                    <Col>
                        <Card className="panel">
                            <Card.Header>
                                <Row>
                                    <Col md={12}>
                                        <h3>Dashboards</h3>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <DashboardsTable />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: AppState) {
    return {
        user: state.oidc.user,
    };
}

export default connect(
    mapStateToProps
)(Dashboards as any);
